import { ColumnFilterType } from '../components/ColumnFilter/ColumnFilterButton';

export const GetViewType = (
    listType: starrez.DirectoryListTypeEnum,
    listID: string | undefined,
    caption: string | undefined
): starrez.DirectoryViewType => {
    // TECH DEBT: replace listType to viewType for DirectoryList Item in graphql
    if ((!listID || listID === '0') && caption) {
        if (caption.includes('All')) {
            return 'ALL_ENTRIES';
        } else if (caption.includes('Active')) {
            return 'ACTIVE_ENTRIES';
        }
    }

    switch (listType) {
        case 'SAVED':
        case 'MY_SAVED':
        case 'SHARED_SAVED':
            return 'SAVED_LIST';
        case 'DYNAMIC':
        case 'MY_DYNAMIC':
        case 'SHARED_DYNAMIC':
            return 'DYNAMIC_LIST';

        default:
        case 'ALL':
            return 'NONE';
    }
};

export const getColumnFilterType = (field: string | undefined): ColumnFilterType => {
    switch (field) {
        case 'nameFirst':
        case 'nameLast':
        case 'namePreferred':
        case 'nameOther':
        case 'email':
        case 'extension_Description':
        case 'extension_Virtual':
        case 'entryID':
        case 'iD1':
        case 'iD2':
        case 'iD3':
        case 'iD4':
        case 'iD5':
            return 'SEARCH';
        case 'roomSpace_Description':
        case 'roomLocation_Description':
        case 'roomType_Description':
        case 'group_Description':
        case 'event_Description':
        case 'applicationStatus_Description':
        case 'level1':
        case 'level2':
        case 'level3':
        case 'level4':
        case 'category_Description':
        case 'termSession_Description':
        case 'classification_Description':
        case 'entryStatus.value':
        case 'genderEnum_Description':
        case 'situationResponse_Description':
            return 'CHECKBOX';
        default:
            return 'NONE';
    }
};
